import { defaultLocale, type Locale, locales } from './config';

type PathnamesMap = Record<string, string | Record<Locale, string>>;

/** Routing config for next-intl (must match middleware). */
export const routing: {
  locales: readonly Locale[];
  defaultLocale: Locale;
  localePrefix: 'never';
  pathnames: PathnamesMap;
} = {
  locales: [...locales],
  defaultLocale,
  localePrefix: 'never',
  pathnames: {} as PathnamesMap,
};
